import { STOCK_URL, IDUSUARIO, customAxios } from "../constants";
import {
  FETCHSKU_CONFIGVEHICULO,
  FETCHSKU_EQUIPOVEHICULO,
  FETCHSKU_CARTECVEHICULO,
  FETCHSKU_ESPTECVEHICULO,
  FETCHSKU_ACCADUVEHICULO,
  FETCHSKU_IMGVEHICULO,
  FETCHSKU_EQUISEGVEHICULO,
  LOAD_MANTENIMIENTO,
  FETCHSKU_INSERT_EQUISEGVEH,
  FETCHSKU_DELETE_EQUISEGVEH,
  FETCHSKU_INSERT_IMAGENVEH,
  FETCHSKU_INSERT_IMAGENVEH_ECOMMERCE,
  FETCHSKU_DELETE_IMAGENVEH,
  FETCHSKU_LIST_TIPOIMAGEN,
  FETCHSKU_LIST_TIPOIMAGEN_ECOMMERCE,
  FETCHSKU_LIST_CONFIGURACION,
  FETCHSKU_LIST_MODELO,
  FETCHSKU_UPDATE_CARTECVEH,
  FETCHSKU_INSERT_CARTECVEH,
  FETCHSKU_LIST_TBCARACTECNI,
  FETCHSKU_RUTA_FIREBASE,
  FETCHSKU_UPDATE_EQUISEGVEH,
  FETCHSKU_UPDATE_EQUIVEH,
  FETCHSKU_UPDATE_IMAGENVEH,
  FETCHSKU_CODAUTO_IMAGEN,
  FETCHSKU_LIST_COLORVEHICULOSKU,
  FETCHSKU_LIST_COLORVEHICULOINTSKU,
} from "../actions";
import { evalAction, serverError } from "../utils/actionError";

export function fetchSkuVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig,
  sku,
  nroPag = 1
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag,
      cantidadxPag: "10",
    },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
    sku: sku,
  };

  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarConfVehSKU`, params, config)
    .then(({ data }) => evalAction(data, "listaSkuVehiculo"))
    .catch((error) => serverError(error, "listaSkuVehiculo"));
  return {
    type: FETCHSKU_CONFIGVEHICULO,
    payload: request,
  };
}

export function fetchEquiposxVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig,
  codTipoEquipo
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
    codTipoEquipo: codTipoEquipo,
    filtro: null,
    accion: null
  };

  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarEquiposVeh`, params, config)
    .then(({ data }) => evalAction(data, "listaEquiVehiculo"))
    .catch((error) => serverError(error, "listaEquiVehiculo"));
  return {
    type: FETCHSKU_EQUIPOVEHICULO,
    payload: request,
  };
}

export function fetchCaracTecxVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
    filtro: null,
    accion: null
  };

  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarCaractTecxVeh`, params, config)
    .then(({ data }) => evalAction(data, "mantCaracTecVehiculo"))
    .catch((error) => serverError(error, "mantCaracTecVehiculo"));
  return {
    type: FETCHSKU_CARTECVEHICULO,
    payload: request,
  };
}

export function fetchEspecTecxVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
  };

  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarEspecTecxVeh`, params, config)
    .then(({ data }) => evalAction(data, "mantEspecTecVehiculo"))
    .catch((error) => serverError(error, "mantEspecTecVehiculo"));
  return {
    type: FETCHSKU_ESPTECVEHICULO,
    payload: request,
  };
}

export function fetchAccAduaxVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
  };

  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/listarAccesoAduanexVeh`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "mantAccAduaVehiculo"))
    .catch((error) => serverError(error, "mantAccAduaVehiculo"));
  return {
    type: FETCHSKU_ACCADUVEHICULO,
    payload: request,
  };
}

export function fetchImagenVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
    filtro: null,
    accion: null
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarImagenVeh`, params, config)
    .then(({ data }) => evalAction(data, "listaImagen"))
    .catch((error) => serverError(error, "listaImagen"));
  return {
    type: FETCHSKU_IMGVEHICULO,
    payload: request,
  };
}

export function fetchEquiSegVehiculo(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarEquiSegVeh`, params, config)
    .then(({ data }) => evalAction(data, "listaSegVeh"))
    .catch((error) => serverError(error, "listaSegVeh"));
  return {
    type: FETCHSKU_EQUISEGVEHICULO,
    payload: request,
  };
}

export function createEquiSegVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfiguracion,
    skuSap: values.skuSap,
    txtEquipamiento: values.txtEquipamiento,
    txtDetalle: values.txtDetalle,
    numeroOrden: values.numeroOrden,
    indInactivo: values.indInactivo,
    codigoTipoVehiculo: "56", //89381
    indImpresion: "S",
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/guardarEquiSegVeh`, params, config)
    .then(({ data }) => evalAction(data, "insertar"))
    .catch((error) => serverError(error, "insertar"));
  return {
    type: FETCHSKU_INSERT_EQUISEGVEH,
    payload: request,
  };
}

export function deleteEquiSegVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codEsv: values.codEsv,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/eliminarEquiSegVeh`, params, config)
    .then(({ data }) => evalAction(data, "eliminar"))
    .catch((error) => serverError(error, "eliminar"));
  return {
    type: FETCHSKU_DELETE_EQUISEGVEH,
    payload: request,
  };
}

export function createImagenVeh(values) {
  console.log(values);
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfiguracion,
    skuSap: values.skuSap,
    tipoImagen: values.tipoImagen,
    numeroOrden: values.numeroOrden,
    txtRutaImagen: values.txtRutaImagen,
    indInactivo: "N",
    alto: values.alto,
    ancho: values.ancho,
    colorVehiculo: values.colorVehiculo,
    colorVehiculoTapiz: values.colorVehiculoTapiz,
    //indTipoWeb: null,
    codImagen: values.codImagen,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/guardarImgVeh`, params, config)
    .then(({ data }) => evalAction(data, "insertar"))
    .catch((error) => serverError(error, "insertar"));
  return {
    type: FETCHSKU_INSERT_IMAGENVEH,
    payload: request,
  };
}

export function deleteImagenVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfiguracion,
    codImagen: values.codImagen,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/eliminarImagenVeh`, params, config)
    .then(({ data }) => evalAction(data, "eliminar"))
    .catch((error) => serverError(error, "eliminar"));
  return {
    type: FETCHSKU_DELETE_IMAGENVEH,
    payload: request,
  };
}

export function fetchTipoImagen() {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: 1,
      cantidadxPag: "10",
    },
  };
  const params = {};
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarTipoImagen`, params, config)
    .then(({ data }) => evalAction(data, "listaTipoImagen"))
    .catch((error) => serverError(error, "listaTipoImagen"));
  return {
    type: FETCHSKU_LIST_TIPOIMAGEN,
    payload: request,
  };
}

export function fetchConfiguraciones(codMarca, codBaumuster) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: 1,
      cantidadxPag: "10",
    },
  };
  const params = {
    codMarca: codMarca,
    codBaumuster: codBaumuster,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarConfiguracion`, params, config)
    .then(({ data }) => evalAction(data, "listaConfiguracion"))
    .catch((error) => serverError(error, "listaConfiguracion"));
  return {
    type: FETCHSKU_LIST_CONFIGURACION,
    payload: request,
  };
}

export function fetchModelos(codFamilia, codMarca) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: 1,
      cantidadxPag: "10",
    },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarModelo`, params, config)
    .then(({ data }) => evalAction(data, "listaModelo"))
    .catch((error) => serverError(error, "listaModelo"));
  return {
    type: FETCHSKU_LIST_MODELO,
    payload: request,
  };
}

export function updateCarTecVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfig,
    codCaractVeh: values.codCaractVeh,
    numeroOrden: values.numeroOrden,
    valorCaract: values.valorCaract,
    indImpresion: values.indImpresion,
    indInactivo: values.indInactivo,
    indImpWeb: values.indImpWeb,
    numOrdenWeb: values.numOrdenWeb,
  };
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/actualizCaractTecVeh`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "actualizar"))
    .catch((error) => serverError(error, "actualizar"));
  return {
    type: FETCHSKU_UPDATE_CARTECVEH,
    payload: request,
  };
}

export function createCarTecVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfig,
    codCaractVeh: values.codCaractVeh,
    numeroOrden: values.numeroOrden,
    valorCaract: values.valorCaract,
    indImpresion: values.indImpresion,
    indInactivo: "N",
    indImpWeb: values.indImpWeb,
    numOrdenWeb: values.numOrdenWeb,
  };
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/insertarCaractTecVeh`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "insertar"))
    .catch((error) => serverError(error, "insertar"));
  return {
    type: FETCHSKU_INSERT_CARTECVEH,
    payload: request,
  };
}

export function fetchCaracterTecnica(codFamilia, codMarca) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
  };
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/listarCaracteristicasTecnicas`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "lista"))
    .catch((error) => serverError(error, "lista"));
  return {
    type: FETCHSKU_LIST_TBCARACTECNI,
    payload: request,
  };
}

export function deleteCarTecVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfigur,
    codCaractVeh: values.codCaractVeh,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/eliminarCaracTecVeh`, params, config)
    .then(({ data }) => evalAction(data, "eliminar"))
    .catch((error) => serverError(error, "eliminar"));
  return {
    type: FETCHSKU_DELETE_EQUISEGVEH,
    payload: request,
  };
}

export function fetchRutaFirebase() {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: 1,
      cantidadxPag: "10",
    },
  };
  const params = {};
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/obtenerRutaAF`, params, config)
    .then(({ data }) => evalAction(data, "rutafirebase"))
    .catch((error) => serverError(error, "rutafirebase"));
  return {
    type: FETCHSKU_RUTA_FIREBASE,
    payload: request,
  };
}

export function fetchCodigoAutoImagen() {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: 1,
      cantidadxPag: "10",
    },
  };
  const params = {};
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/obtenerCodigoAutoImagen`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "rutafirebase"))
    .catch((error) => serverError(error, "rutafirebase"));
  return {
    type: FETCHSKU_CODAUTO_IMAGEN,
    payload: request,
  };
}

export function updateEquiSegVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codEsv: values.codEquiSegVeh,
    txtEquipamiento: values.txtEquipamiento,
    txtDetalle: values.txtDetalle,
    numeroOrden: values.numeroOrden,
    indInactivo: values.indInactivo,
  };
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/actualizarEquiSegVeh`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "actualizar"))
    .catch((error) => serverError(error, "actualizar"));
  return {
    type: FETCHSKU_UPDATE_EQUISEGVEH,
    payload: request,
  };
}

export function updateImagenVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfiguracion,
    tipoImagen: values.tipoImagen,
    numeroOrden: values.numeroOrden,
    alto: values.alto,
    ancho: values.ancho,
    colorVehiculo: values.colorVehiculo,
    colorVehiculoTapiz: values.colorVehiculoTapiz,
    //indTipoWeb: null, // values.indTipoWeb,
    txtRutaImagen: values.txtRutaImagen,
    codImagen: values.codImagen,
  };
  console.log(params);
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/actualizarImgVeh`, params, config)
    .then(({ data }) => evalAction(data, "actualizar"))
    .catch((error) => serverError(error, "actualizar"));
  return {
    type: FETCHSKU_UPDATE_IMAGENVEH,
    payload: request,
  };
}

export function loadMantenimiento() {
  return {
    type: LOAD_MANTENIMIENTO,
  };
}

export function fetchListarColorVehiculoSKU(values) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
    },
  };
  const params = {
    skuSap: values.skuSap,
    codBaumuster: values.codBaumuster,
    codConfigVeh: values.codConfigVeh,
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codClausula: values.codClausulas,
  };
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/listarColorVehiculoSKU`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "listarColorVehiculoSKU"))
    .catch((error) => serverError(error, "listarColorVehiculoSKU"));
  return {
    type: FETCHSKU_LIST_COLORVEHICULOSKU,
    payload: request,
  };
}

export function fetchListarColorVehiculoInteriorSKU(values) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
    },
  };
  const params = {
    skuSap: values.skuSap,
    codColorVeh: values.codColorVeh,
  };
  console.log(params);
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/listarColorVehiculoInteriorSKU`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "listarColorVehiculoInteriorSKU"))
    .catch((error) => serverError(error, "listarColorVehiculoInteriorSKU"));
  return {
    type: FETCHSKU_LIST_COLORVEHICULOINTSKU,
    payload: request,
  };


}

//ecubas 28/05
export function updateEquiVeh(values) {
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codEquipoVeh: values.codEquipoVeh,
    codTipoEquipoVeh: values.codTipoEquipoVeh,
    indImpWeb: values.indImpWeb,
    numOrdenWeb: values.numOrdenWeb,
  };
  const request = customAxios
    .post(
      `${STOCK_URL}/skuvehiculo/skuVeh/actualizarEquiVeh`,
      params,
      config
    )
    .then(({ data }) => evalAction(data, "actualizar"))
    .catch((error) => serverError(error, "actualizar"));
  return {
    type: FETCHSKU_UPDATE_EQUIVEH,
    payload: request,
  };
}

export function createImagenVehEcommerce(values) {
  console.log(values);
  const config = {
    headers: {},
  };
  const params = {
    codFamilia: values.codFamilia,
    codMarca: values.codMarca,
    codBaumuster: values.codBaumuster,
    codConfiguracion: values.codConfiguracion,
    skuSap: values.skuSap,
    tipoImagen: values.tipoImagen,
    numeroOrden: values.numeroOrden,
    txtRutaImagen: values.txtRutaImagen,
    indInactivo: "N",
    alto: values.alto,
    ancho: values.ancho,
    colorVehiculo: values.colorVehiculo,
    colorVehiculoTapiz: values.colorVehiculoTapiz,
    desEcommerce: values.desEcommerce,
    codImagen: values.codImagen,
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/guardarImgVehEcommerce`, params, config)
    .then(({ data }) => evalAction(data, "insertarEcommerce"))
    .catch((error) => serverError(error, "insertarEcommerce"));
  return {
    type: FETCHSKU_INSERT_IMAGENVEH_ECOMMERCE,
    payload: request,
  };
}

export function fetchImagenVehiculoEcommerce(
  codFamilia,
  codMarca,
  codBaumuster,
  codConfig
) {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: "1",
      cantidadxPag: "10",
    },
    //params: { },
  };
  const params = {
    codFamilia: codFamilia,
    codMarca: codMarca,
    codBaumuster: codBaumuster,
    codConfiguracion: codConfig,
    filtro: null,
    accion: null
  };
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarImagenVehEcommerce`, params, config)
    .then(({ data }) => evalAction(data, "listaImagen"))
    .catch((error) => serverError(error, "listaImagen"));
  return {
    type: FETCHSKU_IMGVEHICULO,
    payload: request,
  };
}

export function fetchTipoImagenEcommerce() {
  const config = {
    headers: {
      codUsuario: IDUSUARIO,
      indPaginado: "S", //Al parecer no usa este parámetro pero en el SOAPUI si se lo enviaba
      nroPag: 1,
      cantidadxPag: "10",
    },
  };
  const params = {};
  const request = customAxios
    .post(`${STOCK_URL}/skuvehiculo/skuVeh/listarTipoImagenEcommerce`, params, config)
    .then(({ data }) => evalAction(data, "listaTipoImagen"))
    .catch((error) => serverError(error, "listaTipoImagen"));
  return {
    type: FETCHSKU_LIST_TIPOIMAGEN_ECOMMERCE,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/MantenimientoSkuVehiculo.js